<app-default-progress-bar *ngIf="showProgressBar()"></app-default-progress-bar>

<table [dataSource]="lanesDataTable" class="mat-elevation-z1" mat-table matSort style="width: 100%">
	<ng-container matColumnDef="origin">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Origin</span>
		</th>
		<td *matCellDef="let element" mat-cell>{{ element.origin }}</td>
	</ng-container>

	<ng-container matColumnDef="destination">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Destination</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<span *ngIf="!utilService.isNullOrUndefined(element.destination)">{{
				element.destination
			}}</span>
			<span *ngIf="!utilService.isNullOrUndefined(element.destinationStates)">{{
				element.destinationStates.join(',') | statesDisplay
			}}</span>
		</td>
	</ng-container>

	<ng-container matColumnDef="trailerType">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Trailer Type</span>
		</th>
		<td *matCellDef="let element" mat-cell>{{ element.trailerType }}</td>
	</ng-container>

	<ng-container matColumnDef="confirmationDate">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Confirmation Date</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<span *ngIf="element.confirmationDate">
				{{ element.confirmationDate | date: 'MM/dd/yyyy' }}
			</span>
		</td>
	</ng-container>

	<ng-container matColumnDef="backhaulAvailable">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Backhaul Available</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<mat-slide-toggle [checked]="element.backhaulAvailable" [disabled]="true" color="primary">
			</mat-slide-toggle>
		</td>
	</ng-container>

	<ng-container matColumnDef="frequency">
		<th *matHeaderCellDef mat-header-cell mat-sort-header>
			<span class="fs-13 color-black">Frequency</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			{{ !utilService.isNullOrUndefined(element.frequency) ? element.frequency : '' }}
			{{
				!utilService.isNullOrUndefined(element.frequency) &&
				isFrequencyValidNumber(element.frequency)
					? '/ weekly'
					: ''
			}}
		</td>
	</ng-container>

	<ng-container *ngIf="isActions" matColumnDef="actions">
		<th *matHeaderCellDef mat-header-cell>
			<span class="fs-13 color-black">Actions</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<app-lane-actions
				(lanesListUpdated)="lanesList = $event; emitUpdatedLanesList()"
				[(isLaneUpdating)]="isLaneUpdating"
				[carrier]="carrier"
				[carrierid]="carrierid"
				[contactList]="null"
				[enableProjectSearch]="enableProjectSearch"
				[inputConfig]="inputConfig"
				[lane]="element"
				[lanesList]="lanesList"
			></app-lane-actions>
		</td>
	</ng-container>

	<ng-container *ngIf="!isActions" matColumnDef="actions">
		<th *matHeaderCellDef mat-header-cell>
			<span class="fs-13 color-black">Actions</span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<mat-icon (click)="laneFeedback(element)" class="cursor-pointer primary-text">
				report
			</mat-icon>
		</td>
	</ng-container>

	<ng-container matColumnDef="reviewed">
		<th *matHeaderCellDef mat-header-cell>
			<span class="fs-13 color-black"> Reviewed </span>
		</th>
		<td *matCellDef="let element" mat-cell>
			<mat-checkbox
				(ngModelChange)="carrierLaneApproved(element)"
				[disabled]="!element.toBeReviewed"
				[ngModel]="!element.toBeReviewed"
				color="primary"
			>
			</mat-checkbox>
		</td>
	</ng-container>

	<tr *matHeaderRowDef="lanesColumns" mat-header-row></tr>
	<tr *matRowDef="let row; columns: lanesColumns" mat-row></tr>
</table>

<mat-paginator
	(page)="getCarrierLanes()"
	*ngIf="lanesLength > lanePageSize"
	[length]="lanesLength"
	[pageSizeOptions]="[lanePageSize]"
	class="mat-elevation-z1"
	matSort
	showFirstLastButtons
>
</mat-paginator>
